// {
//     taskId : "t1687186312943",
//     task_name : 'walking',
//     task_description : 'walk 3000 unit steps daily for 21 days',
//     task_quantity : 3000,
//     task_unit : "units",
//     tPeriod : 1
//     task_period_unit : "day"
//     tNumber : 1,
//     times_to_complete : 21 ,
//     start_date:"2023-06-19T20:24",
//     end_date:"2023-06-20T20:24",
//     compul : true
// }
import React, { useEffect, useState } from "react";
import { generateUUID } from "../../components/helpers/uuidgenerator";
import { deleteTaskGroup } from "./Group";
import {
  differenceInDays,
  differenceInMonths,
  differenceInWeeks,
} from "date-fns";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Switch } from "../ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Trash2 } from "lucide-react";

export const Task = ({ formStates, setFormStates, i, j, taskItem }) => {
  const [autoGenerateTaskDescription, setAutoGenerateTaskDescription] =
    useState(true);

  let s =
    taskItem.task_period_unit == "daily"
      ? "days"
      : taskItem.task_period_unit == "monthly"
      ? "months"
      : "weeks";

  const calculateDuration = () => {
    let duration = 0;

    if (taskItem.task_period_unit === "daily") {
      duration = differenceInDays(
        new Date(taskItem.end_date),
        new Date(taskItem.start_date)
      );
    } else if (taskItem.task_period_unit === "monthly") {
      duration = differenceInMonths(
        new Date(taskItem.end_date),
        new Date(taskItem.start_date)
      );
    } else if (taskItem.task_period_unit === "weekly") {
      duration = differenceInWeeks(
        new Date(taskItem.end_date),
        new Date(taskItem.start_date)
      );
    }

    return duration;
  };

  const taskDescription = `${taskItem.task_name} ${taskItem.task_quantity} ${
    taskItem.task_unit
  }  ${taskItem.task_period_unit}${taskItem.tPeriod > 1 ? "s" : ""} for ${
    taskItem.times_to_complete
  } ${s} out of ${calculateDuration()} ${s}`;

  useEffect(() => {
    if (autoGenerateTaskDescription) {
      setFormStates((prev) => {
        let cArr = [...prev.challenge];
        let tArr = cArr[i].task;
        if (autoGenerateTaskDescription) {
          tArr[j] = {
            ...tArr[j],
            task_description: taskDescription,
          };
        }
        return { ...prev, challenge: [...cArr] };
      });
    }
  }, [taskDescription]);

  const handleChange = (i, j, name, value) => {
    setFormStates((prev) => {
      let cArr = [...prev.challenge];
      let tArr = cArr[i].task;
      tArr[j] = { ...tArr[j], [name]: value };
      if (autoGenerateTaskDescription) {
        tArr[j] = {
          ...tArr[j],
          task_description: taskDescription,
        };
      }
      return { ...prev, challenge: [...cArr] };
    });
  };

  const deleteTask = (i, j) => {
    if (taskItem.group_id) {
      deleteTaskGroup(i, taskItem.group_id, setFormStates, taskItem.task_id);
    }

    setFormStates((prev) => {
      let cArr = [...prev.challenge];
      let tArr = [...cArr[i].task];
      let deletedObj = {
        ...prev.deleted,
        task: [...prev.deleted.task, tArr[j]],
      };
      tArr.splice(j, 1);
      cArr[i] = { ...cArr[i], task: [...tArr] };
      let newObj = { ...prev, challenge: [...cArr], deleted: deletedObj };
      return newObj;
    });
  };

  // Format date for datetime-local input
  const formatDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <div id={j} className="space-y-4">
      <div className="flex justify-between items-center">
        <h5 className="text-lg font-semibold">Task no. {j + 1}</h5>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => deleteTask(i, j)}
        >
          <Trash2 className="h-4 w-4 text-red-600" />
        </Button>
      </div>

      <div>
        <Label htmlFor={`task_name_${i}_${j}`}>Task Name</Label>
        <Input
          type="text"
          name="task_name"
          id={`task_name_${i}_${j}`}
          onChange={(e) => {
            handleChange(i, j, e.target.name, e.target.value);
          }}
          value={taskItem.task_name}
          placeholder="e.g., Walking, Running, Skipping"
        />
        <p className="text-sm text-gray-500 mt-1">
          Example: Walking, Running, Skipping, etc.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor={`start_date_${i}_${j}`}>Start Date & Time</Label>
          <Input
            type="datetime-local"
            name="start_date"
            id={`start_date_${i}_${j}`}
            value={formatDateTimeLocal(taskItem.start_date)}
            onChange={(e) =>
              handleChange(i, j, "start_date", new Date(e.target.value))
            }
          />
        </div>
        <div>
          <Label htmlFor={`end_date_${i}_${j}`}>End Date & Time</Label>
          <Input
            type="datetime-local"
            name="end_date"
            id={`end_date_${i}_${j}`}
            value={formatDateTimeLocal(taskItem.end_date)}
            onChange={(e) =>
              handleChange(i, j, "end_date", new Date(e.target.value))
            }
          />
        </div>
      </div>

      <div>
        <Label htmlFor={`task_description_${i}_${j}`}>Task Description</Label>
        <Textarea
          name="task_description"
          id={`task_description_${i}_${j}`}
          placeholder="Walk 2000 steps a day ...."
          onChange={(e) => handleChange(i, j, e.target.name, e.target.value)}
          value={taskItem.task_description}
          rows={3}
        />
        <div className="flex items-center space-x-2 mt-2">
          <Switch
            id={`auto_gen_${i}_${j}`}
            checked={autoGenerateTaskDescription}
            onCheckedChange={() => setAutoGenerateTaskDescription((prev) => !prev)}
          />
          <Label htmlFor={`auto_gen_${i}_${j}`} className="cursor-pointer">
            Auto Generate Task Description
          </Label>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor={`task_quantity_${i}_${j}`}>Task Quantity</Label>
          <Input
            type="number"
            name="task_quantity"
            id={`task_quantity_${i}_${j}`}
            min="0"
            value={taskItem.task_quantity}
            onChange={(e) => handleChange(i, j, e.target.name, e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor={`task_unit_${i}_${j}`}>Unit</Label>
          <Select
            value={taskItem.task_unit}
            onValueChange={(value) => handleChange(i, j, "task_unit", value)}
          >
            <SelectTrigger id={`task_unit_${i}_${j}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="steps">steps</SelectItem>
              <SelectItem value="skips">skips</SelectItem>
              <SelectItem value="units">units</SelectItem>
              <SelectItem value="times">times</SelectItem>
              <SelectItem value="seconds">seconds</SelectItem>
              <SelectItem value="minutes">minutes</SelectItem>
              <SelectItem value="metres">metres</SelectItem>
              <SelectItem value="kilometres">kilometres</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div>
        <Label htmlFor={`task_period_unit_${i}_${j}`}>Period</Label>
        <Select
          value={taskItem.task_period_unit}
          onValueChange={(value) => handleChange(i, j, "task_period_unit", value)}
        >
          <SelectTrigger id={`task_period_unit_${i}_${j}`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="daily">daily</SelectItem>
            <SelectItem value="weekly">weekly</SelectItem>
            <SelectItem value="monthly">monthly</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor={`times_to_complete_${i}_${j}`}>
          Times to Complete (Period for the task to be done?)
        </Label>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            name="times_to_complete"
            id={`times_to_complete_${i}_${j}`}
            min="0"
            value={taskItem.times_to_complete}
            onChange={(e) => handleChange(i, j, e.target.name, e.target.value)}
            className="flex-1"
          />
          <span className="text-sm text-gray-600">{s}</span>
        </div>
      </div>

      <div className="p-3 bg-gray-50 rounded border border-gray-200">
        <p className="text-sm font-semibold italic text-gray-700">
          {taskDescription}
        </p>
      </div>
    </div>
  );
};

export const taskObj = (taskId, group_id) => {
  return {
    task_id: taskId,
    task_name: "",
    task_description: "",
    task_quantity: 0,
    task_unit: "units",
    task_period_unit: "daily",
    times_to_complete: 0,
    start_date: "",
    end_date: "",
    group_id: group_id,
  };
};

export const addTask = (i, setFormStates, group_id, defaultData) => {
  let taskId = "t" + String(generateUUID());
  setFormStates((prev) => {
    let chArr = [...prev.challenge];
    chArr[i] = {
      ...chArr[i],
      task: [
        ...chArr[i].task,
        { ...taskObj(taskId, group_id), ...defaultData },
      ],
    };
    let newObj = { ...prev, challenge: [...chArr] };

    return newObj;
  });
  return taskId;
};

export default Task;
